const GetTicket = () => {
    const handleTicketClick = () => {
        window.location.href = "https://secure.touchnet.net/C20832_ustores/web/store_main.jsp?STOREID=178&SINGLESTORE=true";
    };

    return (
        <div className="my-[52px]  h-[626px] relative bg-black-900_01 md:p-5" id="Tickets">
            <div className="mx-auto flex flex-1 flex-col items-center justify-center">
                <img src="/images/limited-time-offer.svg" className="w-[128px] h-[28px] mobile:!w-[132px] mobile:h-[32.18px]" />
                <h3 
                        className="font-bold text-[48px] mobile:text-[32px] heading ui mt-3 font-switzer mobile:!monasans"
                        style={{
                            textShadow: "0px 20px 50px rgba(0, 0, 0, 0.7)",
                        }}
                    >Get Tickets Now
                </h3>
                <div className="flex justify-center w-full">
                    <div className="absolute opacity-40 blur-[90px] desktop:top-[200px] tablet:top-[200px] rounded-[30px] w-[703px] h-[258px] mobile:w-[329px] mobile:h-[539px] z-[9]" 
                        style={{
                        backgroundImage: "linear-gradient(-87.56deg, rgba(147, 232, 255, 1) 0%, rgba(119, 122, 255, 1) 100%)",
                    }} />
                    <div className="rounded-[30px] py-[38px] gap-[42px] pl-[62px] desktop:w-[759px] tablet:w-[627px] mobile:w-[329px] mt-[42px] 
                            flex self-stretch border border-solid border-white-a700_0c pr-14 desktop:flex-row tablet:flex-row 
                            desktop:px-5 tablet:px-5 mobile:flex-col mobile:p-5 border border-[1px] border-[rgba(255, 255, 255, 0.05)
                            bg-[#111115cc] z-10">
                        <div className="desktop:w-[46%] tablet:w-[46%] desktop:my-3.5 tablet:my-3.5 flex flex-col items-center sm:my-0 sm:w-full desktop:ml-[50px]">
                            <h4 className="text-medium text-[18px] heading ui ml-3 self-start !font-switzer !text-white-a700_cc md:ml-0">
                                Students
                            </h4>
                            <div className="h-[80px] relative mx-3 content-center self-stretch md:mx-0 md:h-auto">
                                <div className="flex flex-1 flex-col items-start">
                                    <h5 className="text-[48px] font-bold heading ui ml-[18px] !font-switzer md:ml-0">45</h5>
                                </div>
                                <h3 className="font-bold desktop:text-[25px] text-[28px] heading ui top-[12.5px] mobile:top-[10.5px] absolute left-0 m-auto font-switzer mobile:font-monasans">$</h3>
                            </div>
                            <button className="fill font-medium text-[18px] white_a700_19 button ui !rounded-[16px] text-[18px] px-[34px] h-[58px] mt-3 self-stretch !bg-white-a700_19 font-monasans mobile:font-monasans font-medium !text-white sm:px-5 cursor-pointer hover:!bg-white-a700_4c btn-get-ticket-border hover:border-[1px]"
                                    onClick={handleTicketClick}>
                                Get Tickets
                            </button>
                        </div>
                        <div className="rounded-[1px] desktop:h-[220px] desktop:w-px tablet:h-[220px] tablet:w-px mobile:h-px mobile:w-[282px] bg-blue_gray-100_19"></div>
                        <div className="desktop:w-[46%] tablet:w-[46%] desktop:my-3.5 tablet:my-3.5 flex flex-col items-center sm:my-0 sm:w-full desktop:mr-[50px]">
                            <h4 className="text-medium text-[18px] heading ui ml-3 self-start !font-switzer !text-white-a700_cc md:ml-0">
                                Professionals
                            </h4>
                            <div className="h-[80px] relative mx-3 content-center self-stretch md:mx-0 md:h-auto">
                                <div className="flex flex-1 flex-col items-start">
                                    <h5 className="text-[48px] font-bold heading ui ml-[18px] !font-switzer md:ml-0">65</h5>
                                </div>
                                <h3 className="font-bold desktop:text-[25px] text-[28px] heading ui top-[12.5px] mobile:top-[10.5px] absolute left-0 m-auto font-switzer mobile:font-monasans">$</h3>
                            </div>
                            <button className="fill font-medium text-[18px] white_a700_19 button ui !rounded-[16px] text-[18px] px-[34px] h-[58px] mt-3 self-stretch !bg-white-a700_19 font-monasans mobile:font-monasans font-medium !text-white sm:px-5 cursor-pointer hover:!bg-white-a700_4c btn-get-ticket-border hover:border-[1px]"
                                    onClick={handleTicketClick}>
                                Get Tickets
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default GetTicket;